import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userManager } from '../lib/auth';

/**
 * Lands the redirect back from the Cognito hosted UI.
 *
 * signinRedirectCallback exchanges the authorization code for tokens using the
 * PKCE verifier, and validates state and nonce. If that fails the user is told
 * rather than silently bounced, otherwise a misconfigured callback URL looks
 * like an infinite redirect loop.
 */
const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    userManager
      .signinRedirectCallback()
      .then(() => {
        if (cancelled) return;
        // Replace so the code-bearing URL does not stay in history.
        navigate('/admin', { replace: true });
      })
      .catch((e: unknown) => {
        if (cancelled) return;
        console.error('Sign-in callback failed:', e);
        setError(e instanceof Error ? e.message : 'Sign-in failed');
      });

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (error) {
    return (
      <div style={wrap}>
        <h2>Sign-in failed</h2>
        <p style={{ color: '#6b7280' }}>{error}</p>
        <button style={button} onClick={() => (window.location.href = '/')}>
          Try again
        </button>
      </div>
    );
  }

  return <div style={wrap}>Signing you in…</div>;
};

const wrap: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60vh',
  gap: 12,
  fontFamily: 'system-ui, sans-serif',
  textAlign: 'center',
  padding: 24
};

const button: React.CSSProperties = {
  padding: '8px 18px',
  borderRadius: 6,
  border: '1px solid #2563eb',
  background: '#2563eb',
  color: '#fff',
  fontWeight: 600,
  cursor: 'pointer'
};

export default AuthCallback;
